import { defineHubSection, type HubSectionData } from '@/components/Hub/hubSectionTypes';
import { simulationsNavIcons } from '@/components/Hub/hubNavIcons';

const NO_SIMULATIONS: HubSectionData = { slides: [], isLoading: false, isError: false };

const useSimulationsData = (): HubSectionData => NO_SIMULATIONS;

export const simulationsSection = defineHubSection({
    id: 'simulations',
    title: 'Simulations',
    blurb: '',
    navIcons: simulationsNavIcons,
    viewAll: null,
    endCard: null,
    itemBasisClassName: 'basis-[86%] sm:basis-[82%]',
    useData: useSimulationsData,
});
